<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import { faSave } from '@fortawesome/free-solid-svg-icons'
    import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import DateSelect from '../_common/date-select.svelte'

    import dayjs from 'dayjs'
    import { AppointmentsSelectAppointmentEntity, AppointmentsSelectEntity } from './appointments-select.entity'
    import Transition from '../_common/transition.svelte'
    import { AppointmentStatus } from '../../modules/schedulerApi/appointments/appointments.enum'
    const dispatch = createEventDispatcher()

    export let personId: string = null

    let dates: { from: Date; to: Date } = window.api.utils.dates.today()
    let appointments: AppointmentsSelectAppointmentEntity[] = []
    let show = false

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    onMount(async () => {
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            appointments = []
            const entities: Appointment[] = await window.api.schedulers.appointments.getAll({
                personId: personId || undefined,
                from: dates.from,
                to: dates.to,
            })
            for (let ap of entities) {
                ap.items = await window.api.utils.utils.assignServicesFromObject(ap.items)
            }
            for (const ap of entities) {
                if (ap.status === AppointmentStatus.agendamento_bloqueado) continue
                if (ap.status === AppointmentStatus.agendamento_disponivel) continue
                if (ap.status === AppointmentStatus.agendamento_excluido) continue
                let dto: AppointmentsSelectAppointmentEntity = {
                    personId: ap.personId,
                    selected: false,
                    appointment: ap,
                    items: [],
                }
                for (const item of ap.items) {
                    dto.items.push({
                        selected: false,
                        item: item,
                    })
                }
                appointments.push(dto)
            }
            appointments = await window.api.utils.utils.assignPersonsFromObject(appointments)
            appointments = appointments
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let selectedPersonId = null
    function onApSelectedChanged(ap: AppointmentsSelectAppointmentEntity) {
        evaluateSelectedPerson()
        for (let item of ap.items) {
            item.selected = ap.selected
        }
        appointments = appointments
    }

    function evaluateSelectedPerson() {
        selectedPersonId = null
        for (const ap of appointments) {
            if (ap.selected) {
                selectedPersonId = ap.personId
                break
            }
            for (const item of ap.items) {
                if (item.selected) {
                    selectedPersonId = ap.personId
                    break
                }
            }
            if (selectedPersonId) break
        }
    }

    function onApItemSelectedChanged(ap, item) {
        evaluateSelectedPerson()
    }

    let selecteds: AppointmentsSelectEntity = new AppointmentsSelectEntity()
    selecteds.statusAttended = !!window.configs.scheduleAutoCommitStatus

    function goSelect() {
        selecteds.appointments = []
        for (const ap of appointments) {
            let dto: AppointmentsSelectAppointmentEntity = null
            for (const item of ap.items) {
                if (!item.selected) continue
                if (!dto) {
                    dto = new AppointmentsSelectAppointmentEntity()
                    dto.selected = true
                    dto.appointment = ap.appointment
                    dto.personId = ap.personId
                    dto.person = ap.person
                    dto.items = []
                }
                dto.items.push(item)
            }
            if (!dto) continue
            selecteds.appointments.push(dto)
        }
        dispatch('import', selecteds)
    }
</script>

<div class="root">
    <div class="grid-act">
        <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
        <div class="spacer" />

        <button class="btn btn-primary" on:click={goSelect}><Fa icon={faSave} /> Importar</button>
    </div>

    <div class="config-box m-3">
        <div class="apselect_status">
            <div class="spacer"></div>
            <div class="form-check form-switch">
                <input class="form-check-input" bind:checked={selecteds.statusAttended} type="checkbox" role="switch" id="consulting" />
                <label class="form-check-label" for="consulting">Ao salvar mudar agendamento para "Compareceu"</label>
            </div>
        </div>
        {#each appointments as ap}
            {#if !selectedPersonId || selectedPersonId === ap.personId}
                <Transition>
                    <div class="apselect_ap">
                        <div class="apselect_ap_head">
                            <div class="apselect_ap_select">
                                <input type="checkbox" bind:checked={ap.selected} on:change={() => onApSelectedChanged(ap)} />
                            </div>
                            <div class="apselect_ap_title">
                                <div class="-name">{ap.person?.name}</div>
                                <div class="-spacing">-</div>
                                <div class="-date">
                                    agendado em {dayjs(ap.appointment.start).format('DD/MM/YYYY HH:mm')}
                                </div>
                            </div>
                        </div>
                        <div class="apselect_ap_body">
                            {#each ap.items as item}
                                <div class="apselect_ap_body_item">
                                    <div class="apselect_ap_body_item_select">
                                        <input type="checkbox" bind:checked={item.selected} on:change={() => onApItemSelectedChanged(ap, item)} />
                                    </div>
                                    <div class="apselect_ap_body_item_title">
                                        {item.item.service?.name || '[serviço não identificado]'}
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                </Transition>
            {/if}
        {/each}
    </div>
</div>

<style>
    .apselect_ap {
        border: 1px solid #99999960;
        border-radius: 8px;
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .apselect_status {
        display: flex;
        font-size: 14px;
    }
    .apselect_ap_head {
        display: flex;
        align-items: center;
        padding: 4px;
        background-color: #99999930;
    }
    .apselect_ap_select {
        margin-right: 8px;
    }
    .apselect_ap_title {
        display: flex;
        font-weight: 400;
    }
    .apselect_ap_title .-name {
        color: var(--bs-success);
    }
    .apselect_ap_title .-spacing {
        padding: 0px 3px;
    }

    .apselect_ap_body {
    }
    .apselect_ap_body_item {
        display: flex;
        margin-bottom: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid #99999930;
    }
    .apselect_ap_body .apselect_ap_body_item:last-child {
        border-bottom: unset;
    }
    .apselect_ap_body_item_select {
        margin-left: 22px;
        margin-right: 8px;
    }
    .apselect_apbody_item_title {
    }

    @media (max-width: 900px) {
        .root {
            display: flex;
            flex-direction: column-reverse;
        }
        .grid-act {
            background-color: unset;
            display: flex;
            justify-content: space-around;
        }
        .grid-act .btn {
            max-width: 120px;
            flex-grow: 1;
        }
    }
</style>
